function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreePointX24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2780",
    d: "M12 2 1 20h22z",
    style: {
      fill: "none",
      stroke: "#3e4346"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2781",
    d: "M12 6l7 12H5z",
    style: {
      fill: "#529f40"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreePointX24);
export default __webpack_public_path__ + "static/media/tree-point-x24.913afea95ac14e8d1d53e6a96cca65ea.svg";
export { ForwardRef as ReactComponent };